import { supabase } from './supabase';

/**
 * Funciones para manejar la foto de perfil del usuario
 * Permite guardar y pre-cargar automáticamente la foto del usuario
 */

export interface UserProfilePhoto {
    id: string;
    user_id: string;
    photo_url: string;
    photo_source: string | null;
    created_at: string;
    updated_at: string;
}

/**
 * Guarda o actualiza la foto de perfil del usuario
 */
export async function saveUserProfilePhoto(
    userId: string,
    photoUrl: string,
    photoSource: string = 'upload'
): Promise<{ success: boolean; error?: string }> {
    try {
        const { error } = await supabase
            .from('user_profile_photo')
            .upsert(
                {
                    user_id: userId,
                    photo_url: photoUrl,
                    photo_source: photoSource,
                    updated_at: new Date().toISOString(),
                },
                {
                    onConflict: 'user_id',
                }
            );

        if (error) throw error;

        console.log('✅ Foto de perfil guardada exitosamente');
        return { success: true };
    } catch (error) {
        console.error('Error guardando foto de perfil:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
        };
    }
}

/**
 * Obtiene la foto de perfil guardada del usuario
 */
export async function getUserProfilePhoto(
    userId: string
): Promise<{ success: boolean; data?: UserProfilePhoto; error?: string }> {
    try {
        const { data, error } = await supabase
            .from('user_profile_photo')
            .select('*')
            .eq('user_id', userId)
            .single();

        if (error) {
            // Si no existe, no es un error crítico
            if (error.code === 'PGRST116') {
                return { success: true, data: undefined };
            }
            throw error;
        }

        console.log('✅ Foto de perfil cargada');
        return { success: true, data };
    } catch (error) {
        console.error('Error obteniendo foto de perfil:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
        };
    }
}

/**
 * Elimina la foto de perfil guardada del usuario
 */
export async function deleteUserProfilePhoto(
    userId: string
): Promise<{ success: boolean; error?: string }> {
    try {
        const { error } = await supabase
            .from('user_profile_photo')
            .delete()
            .eq('user_id', userId);

        if (error) throw error;

        console.log('✅ Foto de perfil eliminada');
        return { success: true };
    } catch (error) {
        console.error('Error eliminando foto de perfil:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
        };
    }
}
